import { VisualObjectOptions } from "./visualObjectOptions";

export class TabOptions {

  visualObject: VisualObjectOptions;

}